<template>
    <button type="button" class="btn rounded-pill" :class="btnClass" style="min-width: 110px;" :disabled="store.loading">
        <slot><i class="fa-solid fa-chevron-right"></i>weiter</slot>
        <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true" v-if="store.loading"></span>
    </button>
</template>
<script setup>
import { computed } from "vue"
import { store } from "../../store";
const props = defineProps({
    variant: {
        type: String,
        default: 'primary'
    }
})
const btnClass = computed(() => 'btn-outline-' + props.variant)
</script>

